import { GeneratedFileCard } from "#features/conversations/components/generated-files/GeneratedFileCard.tsx";
import type { GeneratedFile } from "#types/types.ts";
import { Flex } from "@hopper-ui/components";

interface Props {
    files?: GeneratedFile[] | null;
}

export const AssistantMessageGeneratedFiles = ({ files }: Props) => {
    if (!files || files.length === 0) {
        return null;
    }

    return (
        <Flex direction="column" gap="inline-sm">
            {files.map(file => <GeneratedFileCard key={file.downloadUrl} file={file} />)}
        </Flex>
    );
};
